// TODO move this
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");

var SearchFilterInteractionModel = function (ind, dataType) {
    lib_core.Model.call(this);
    var self = this;

    this.dataType = dataType;
    this.properties = cio_config.MetaProperties[dataType];

    this.currentProperty = null;
    this.isKeyCorrect = false;
    this.isValCorrect = false;

    this.index = this.value('index', true);
    this.index(ind);

    this.key = this.value('key', true);
    this.val = this.value('val', true);

    // these shadows are being used a bit differently, which I believe ok because they are used to set interaction data,
    // not real data.  The above values will be set by the shadows regardless of the data; but the shadows will return
    // false if that is good data or not.  Then we are still able to save values as users type, but can still 
    // change the values onBlur (to add units) because the HTMl is coupled with the above values.  But when setting
    // the values, the html can turn the boxes red when the value is not good, and the same return is used for 
    // whether or not to activate a search.
    this.keyShadow = this.shadow('keyShadow', 
        function(){
            return this.key();
        }, function(value){

            this.key(value);
            this.currentProperty = this.getPropByServerName(value);
            this.isKeyCorrect = (this.currentProperty)? true: false;
            return this.isKeyCorrect;
        },
        [this.key]
    );

    this.valShadow = this.shadow('valShadow', 
        function(){
            return this.val();
        }, function(value){

            this.val(value);
            // empty str is acceptable value, it will cause the filter to be ignored
            if( this.val() === ""){
                this.isValCorrect = true;
                return true;
            } 
            if(this.currentProperty == null) this.isValCorrect = false;
            else this.isValCorrect = this.canConvert(this.currentProperty, value);
            
            return this.isValCorrect;
        },
        [this.val]
    );

}
lib_core.inherit(SearchFilterInteractionModel, lib_core.Model);
lib_core.JsonParser.registerClass(SearchFilterInteractionModel, "SearchFilterInteractionModel");

SearchFilterInteractionModel.prototype.decreaseIndex = function(){
    this.index(this.index() - 1);
}
// the key will be the server name, because that is what search needs.  So use this function
// to get the property info associated with that name.
SearchFilterInteractionModel.prototype.getPropByServerName = function(serverName){
    for(var key in this.properties){
        if(this.properties.hasOwnProperty(key) && this.properties[key].serverName && this.properties[key].serverName == serverName){
            return this.properties[key];
        }
    }
    return null;
}

// standard func to check if data (string or number) is value
SearchFilterInteractionModel.prototype.isValid = function(val) {
    if(typeof val != "string" && isNaN(val)){
        return false;
    } else if(val === null){
        return false;
    } else {
        return true;
    }
};

// check if the data is good data
SearchFilterInteractionModel.prototype.canConvert = function(propInfo, data){
    if(data === NaN || data === undefined || data === null) return false;

    if(!data==="") return true;

    // if unity but no type, assume converting from micrometers, it must be numerical
    if(propInfo.unit && !propInfo.type){
        data = cio_config.UnitConversions.convert("um", propInfo.unit, data);
        if(!this.isValid(data)) return false;
        return true;
    }
    // if type but no unit, parse only (could be string or unitless number)
    else if(!propInfo.unit && propInfo.type){
        data = propInfo.type.parser(data);
        if(!this.isValid(data)) return false;
        return true;
    }
    // all unit-compatable types should have a reader
    else if(propInfo.type && propInfo.unit){
        if(propInfo.type.reader){
            data = propInfo.type.reader(data, propInfo.unit);
            if(!this.isValid(data)) return false;
        }
        return true;
    }
    return true;
}
 
// convert the data entered into 'proper format' (i.e. 1in => 2.54mm, or 1 => 1mm)
SearchFilterInteractionModel.prototype.convertAndSet = function(){
    var propInfo = this.currentProperty;
    if(!this.isKeyCorrect) return false;
    if(!this.isValCorrect) return false;
    if(!propInfo) return false;

    var data = this.valShadow();

    if(data === null || data === NaN || data === undefined) return false;

    if(propInfo.unit && !propInfo.type){
        data = cio_config.UnitConversions.convert("um", propInfo.unit, data);
        if(!this.isValid(data)) return false;
      
    }
    // if type but no unit, parse only (could be string or unitless number)
    else if(!propInfo.unit && propInfo.type){
        data = propInfo.type.parser(data);
        if(!this.isValid(data)) return false;
        return data;
        
    }
    // all unit-compatable types should have a reader
    else if(propInfo.type && propInfo.unit){
        if(propInfo.type.reader){
            data = propInfo.type.reader(data, propInfo.unit);
            if(!this.isValid(data)) return false;
            data = data + propInfo.unit;
        }
      
    }
    this.valShadow(data);
    return true;
}

// undo the conversion to 'proper format', this is for the search tabs to grab
// the actual data they should use for the search (always in um)
SearchFilterInteractionModel.prototype.getRealValue = function(shadow){
    var data = shadow();
    var propInfo = this.currentProperty;
    if(!propInfo || data === null) return null;
    if(propInfo.unit && !propInfo.type){
        data = cio_config.UnitConversions.convert(propInfo.unit, "um", data);
        if(!this.isValid(data)) return null;
        return data;
    }
    // if type but no unit, parse only (could be string or unitless number)
    else if(!propInfo.unit && propInfo.type){
        data = propInfo.type.parser(data);
        if(!this.isValid(data)) return null;
        return data
        
    }
    // all unit-compatable types should have a reader
    else if(propInfo.type && propInfo.unit){
        if(propInfo.type.reader){
            if(!cio_config.UnitConversions.hasUnit(data)) data = data + propInfo.unit;
            data = propInfo.type.reader(data, "um");
            if(!this.isValid(data)) return null;
            return data;
        }
      
    } else {
        // if here its an enum!
        return data;
    }

}

module.exports = SearchFilterInteractionModel;


